import {
    AVAILABLITY_LIST_GET_LIST,
    AVAILABLITY_LIST_GET_LIST_SUCCESS,
    AVAILABLITY_LIST_GET_LIST_ERROR,
    AVAILABLITY_LIST_GET_LIST_WITH_FILTER,  
} from '../actions';


export const getAvailablityList = () => ({
    type: AVAILABLITY_LIST_GET_LIST
});

export const getAvailablityListSuccess = (rooms,roomdetails) => ({
    type: AVAILABLITY_LIST_GET_LIST_SUCCESS,
    payload: {rooms,roomdetails}
});

export const getAvailablityListError = (error) => ({
    type: AVAILABLITY_LIST_GET_LIST_ERROR,
    payload: error
});

export const getAvailablityListWithFilter = (column, value) => ({
    type: AVAILABLITY_LIST_GET_LIST_WITH_FILTER,
    payload: { column, value }
});

export const getAvailablityListSearch = (startDate) => ({
    type: AVAILABLITY_LIST_GET_LIST_WITH_FILTER,
    payload: {startDate}
});